import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { ControlDeletionService } from 'src/app/_services/control-deletion.service';
import { StudentService } from 'src/app/user-management/_services/student.service';
import { UserService } from 'src/app/_services/user.service';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { ParentService } from 'src/app/user-management/_services/parent.service';
import { RoutesService } from 'src/app/buses/_services/routes.service';
import { BusStudentsService } from 'src/app/buses/_services/bus-students.service';
import { GatesService } from 'src/app/school-management/_services/gates.service';
import { MessagesControlService } from 'src/app/_services/messages-control.service';
import { GradeService } from 'src/app/school-management/_services/grades.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarService } from 'src/app/_services/snackBar.service';
import { SnackBarErrorComponent } from 'src/app/components/snack-bar-error/snack-bar-error.component';
import { TranslateService } from '@ngx-translate/core';
import { GlobalService } from 'src/app/_services/global.service';
import { ErrorMsgService } from 'src/app/shared/error-msg/error-msg.service';
import { DelegationService } from 'src/app/delegation/_services/delegation.service';

declare var $: any;

@Component({
  selector: 'app-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.scss']
})
export class DeleteModalComponent implements OnInit {

  toBeDeletedRows: [];
  rowsType: string;
  gate;
  grade;
  password: string = null;
  passwordMismatch: string = null;
  noOfShownRows: number;
  currLang;
  delegationMsg="Delegations";

  constructor(private parentService: ParentService,
    private routeService: RoutesService,
    private dataService: DataService,
    private userService: UserService,
    private controlDeletion: ControlDeletionService,
    private controlMessaging: MessagesControlService,
    private studentService: StudentService,
    private gatesService: GatesService,
    private gradesServie: GradeService,
    private _snackBar: MatSnackBar,
    private snackBar: SnackbarService,
    private errorMsgService: ErrorMsgService,
    private translate: TranslateService,
    private busStudentService: BusStudentsService,
    private globalService: GlobalService,
    private delegationService: DelegationService,

    
  ) {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
  }

  ngOnInit(): void {
    $(document).on('hidden.bs.modal', '#deleteModal', () => {
      this.cancelModalHandler();
    })

    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });

    this.controlDeletion.getDeletedRows().subscribe(res => {      
      // the old number of rows is showed ... to get the same number after deletion
      if (res.type === 'gates') {
        this.rowsType = res.type;
        this.gate = res.gate;
      }
      if (res.type === 'grades') {
        this.rowsType = res.type;
        this.grade = res.grade;
      }
      else {
        this.noOfShownRows = res.noOfShownRows;
        this.rowsType = res.type;
        this.toBeDeletedRows = res.rows_array;
      }
    })
  }

  getConfirmBtnLabel() {
    let label = this.rowsType === 'gates' ? this.translate.instant('delete-modal.continue') : this.translate.instant('delete-modal.confirm')
    return label;

  }

  deleteRows() {
    // verify password first
    let password_body = { 'password': this.password }
    this.userService.verifyPassword(password_body).subscribe((res: any) => {

      // else {
      // deleting students
      if (this.rowsType === 'students') {
        let studnent_ids = [];
        this.toBeDeletedRows.map((oneRow: any) => {
          studnent_ids.push(oneRow.id);
        })
        let body = { 'student_ids': studnent_ids }
        this.studentService.deleteStudents(body).subscribe(res => {
          this.closeModalHandler();
        })
      }
      else if (this.rowsType === 'routes') {
        let body = { 'route_ids': this.toBeDeletedRows }
        this.routeService.deleteRoutes(body).subscribe(res => {
          this.closeModalHandler();
        })
      } else if (this.rowsType === 'bus-students') {
        let rowsIds = [];
        this.toBeDeletedRows.map((row: any) => {
          rowsIds.push(row.id)
        })
        let body = { 'students_ids': rowsIds }
        this.busStudentService.deleteStudents(body).subscribe(res => {     
          this.dataService.setSearchText('');     
          this.closeModalHandler();
        })
      }
      // delegation bulk delete
      else if (this.rowsType === 'listing') {
        let rowsIds = [];
        this.toBeDeletedRows.map((row: any) => {
          rowsIds.push(row.request_id)
        })
        let body = {'delegation_request_ids': rowsIds }        
        this.delegationService.deleteDelegationRequets(body).subscribe(res => {
          this.closeModalHandler();
        },err=>{
          console.log(`error (${err.status})`);
          this.errorMsgService.setMessage(err.error.message)
        })
      }
      else if (this.rowsType === 'gates') {
        
        // if (this.gate.grades?.length > 0) {
        //   this.gatesService.setGateData(this.gate);
        //   $("#assignGateModal").modal("show");
        // }
        // else {
        //   this.gatesService.deleteGate(this.gate.id).subscribe(res => {
        //     this.gatesService.setGatesReload();
        //     let filteredGates=this.dataService.allGates.filter(gate=> gate.id !== this.gate.id);
        //     this.dataService.setAllGates$(filteredGates)
        //     this.closeModalHandler();
        //   })
        // }
        this.gatesService.deleteGate(this.gate.id).subscribe(res => {
              this.gatesService.setGatesReload();
              let filteredGates=this.dataService.allGates.filter(gate=> gate.id !== this.gate.id);
              this.dataService.setAllGates$(filteredGates)
              this.closeModalHandler();
            },(error=>{
              this.snackBar.setSnackBarMessage(error.error.message);
              this._snackBar.openFromComponent(SnackBarErrorComponent, {
                duration: 5000,
                horizontalPosition: 'center',
                verticalPosition: 'top',
              });
            }))
      }
      else if (this.rowsType === 'grades') {
        this.gradesServie.deleteGrade(this.grade.id).subscribe((res: any) => {
          this.gradesServie.setGradesReload();
          
         let filteredGrades=this.dataService.allGrades.filter(grade=> grade.id !== this.grade.id);
          this.dataService.setAllGrades$(filteredGrades)
          // to update gates after grade deletion to reflect in the assigned grade in gate card 
          this.dataService.updateGatesCache();
          this.closeModalHandler();
        }, (error) => {
          this.snackBar.setSnackBarMessage(error.error.message);
          this._snackBar.openFromComponent(SnackBarErrorComponent, {
            duration: 5000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          });
        })
      }
      else {
        // deleteing parents or staff
        const roleMap: { [key: string]: string } = {
          parents: 'parent',
          assistants: 'helper',
        };
        let role = roleMap[this.rowsType] || 'staff';
        let user_ids = [];
        this.toBeDeletedRows.map((oneRow: any) => {
          user_ids.push(oneRow.id);
        })
        let body = { 'role': role, 'user_ids': user_ids }
        // delete parents is same as delete users 
        this.parentService.deleteParents(body).subscribe(res => {
          //  set the checkbox value as an observable of empty array after deletion is done
          this.controlDeletion.setCheckbox([])
          this.closeModalHandler();
        },err=>{
          if(err.error.errors['user_ids.0']){
            this.cancelModalHandler();
            this.errorMsgService.setMessage(this.translate.instant(`delete-modal.delete-admin`))
          }
        })
      }
      
    }, err => {
      this.passwordMismatch = err.error.message;
    })
  }

  cancelModalHandler() {
    this.password = null;
    this.passwordMismatch = null;
    $("#deleteModal").modal("hide");
  }

  closeModalHandler() {
    this.password = null;
    this.passwordMismatch = null;
    this.controlDeletion.resetSelectedRows();
    this.dataService.setRowsNumberShown(this.noOfShownRows);
    this.controlDeletion.toggleDeleteBtn(false);
    this.controlMessaging.toggleMessageBtn(false);
    $("#deleteModal").modal("hide");
  }
}
